<template>
    <v-container fluid fill-height>
        <v-layout row>
            <v-flex xs8 sm6 offset-sm3>
                <v-layout row>
                    <v-flex xs8 sm6 offset-sm3>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-btn flat icon @click="reloadProjects"><v-icon>cached</v-icon></v-btn>
                    </v-flex>
                </v-layout>
                <component v-on:close="reloadProjects" :is="getType()" :projects="projectItems" :search="search" :loading="!projects"></component>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
    import { mapGetters } from "vuex";
    import GcpProjectTable from './GcpProjectTable';
    import FirebaseProjectTable from './FirebaseProjectTable';

    export default {
        name: "Projects",
        props: {
            type: {
                type: String,
                enum: ['gcp', 'firebase'],
                required: true,
            }
        },
        data() {
            return {
                search: '',
            }
        },
        components: { GcpProjectTable, FirebaseProjectTable },
        created() {
            this.$store.dispatch('projects/list', { type: this.type })
        },
        computed: {
            ...mapGetters({
                firebaseProjects: "projects/firebaseProjects",
                gcpProjects: "projects/gcpProjects",
            }),
            projectItems() {
                return this.projects || [];
            },
            projects() {
                return this.type === 'gcp' ? this.gcpProjects : this.firebaseProjects;
            }
        },
        methods: {
            getType() {
                return `${this.type}-project-table`;
            },
            reloadProjects() {
                this.$store.dispatch('projects/list', { type: this.type });
            }
        }
    };
</script>

<style>
    .list-card {
        margin-top: 30px;
        min-height: 100px;
    }
</style>
